import { render, staticRenderFns } from "./RequestByType.vue?vue&type=template&id=134be59e&"
import script from "./RequestByType.vue?vue&type=script&lang=js&"
export * from "./RequestByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports